import { IUserSummarySettingsModel } from '@fi-shared/models/user.model';

export class UserSummarySettingsModel {
    IsChecklist = true;
    IsChecklistReport = true;
    IsUserRequest = true;
    IsNewPage = true;
    IsNewFile = true;
    IsPost = true;
    IsForum = true;
    IsForm = true;
    IsPersonalNotification = true;

    IsDailyFrequency = false;
    IsWeeklyFrequency = true;

    IsSystemNotificationPushMessage = true;
    IsSocialActivityPushMessage = true;
    IsTodoPushMessage = true;

    constructor(data?: IUserSummarySettingsModel) {
        if (data) {
            this.initialize(data);
        }
    }

    initialize(data: IUserSummarySettingsModel) {
        this.IsUserRequest = data.IsUserRequest;
        this.IsNewPage = data.IsNewPage;
        this.IsNewFile = data.IsNewFile;
        //this.IsChecklist = data.IsChecklist; mandatory
        this.IsChecklistReport = data.IsChecklistReport;
        this.IsPost = data.IsPost;
        this.IsForum = data.IsForum;
        this.IsForm = data.IsForm;
        this.IsPersonalNotification = data.IsPersonalNotification;

        this.IsDailyFrequency = data.IsDailyFrequency;
        this.IsWeeklyFrequency = data.IsWeeklyFrequency;

        this.IsSystemNotificationPushMessage = data.IsSystemNotificationPushMessage;
        this.IsSocialActivityPushMessage = data.IsSocialActivityPushMessage;
        this.IsTodoPushMessage = data.IsTodoPushMessage;
    }
}
